import { atomWithStorage, createJSONStorage } from "jotai/utils";
import type { AppliedCouponSessionPayload } from "@/types/coupon";
import { CheckoutPayload } from "@/hooks/booking-checkout/booking.checkout.helpers";

const noopStorage = {
  getItem: () => null,
  setItem: () => { },
  removeItem: () => { },
};

const spaCheckoutStorage = createJSONStorage<CheckoutPayload | null>(
  () => (typeof window === "undefined" ? noopStorage : window.sessionStorage),
);

export const spaCheckoutPayloadAtom =
  atomWithStorage<CheckoutPayload | null>(
    "tovtrip_spa_checkout_payload",
    null,
    spaCheckoutStorage,
    { getOnInit: true },
  );

const spaAppliedCouponStorage =
  createJSONStorage<AppliedCouponSessionPayload | null>(() =>
    typeof window === "undefined" ? noopStorage : window.sessionStorage,
  );

export const spaAppliedCouponAtom =
  atomWithStorage<AppliedCouponSessionPayload | null>(
    "tovtrip_spa_applied_coupon",
    null,
    spaAppliedCouponStorage,
    { getOnInit: true },
  );

export const spaTicketSelectionAtom =
  atomWithStorage<any | null>(
    "tovtrip_spa_ticket_selection",
    null,
    spaCheckoutStorage,
    { getOnInit: true },
  );